import AxiosClient from "../../../services/axios.services";

class DashboardJefeServices {
  getDashboardJefeObjetivos = (params, id) =>
    AxiosClient.get("/api/app/dashboard_evaluaciones_objetivos_jefe/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
}

export default new DashboardJefeServices();
